import {
    licensesPaymentConstants,
    licensesPaymentFulfilledConstants,
    licensesPaymentPendingConstants,
    licensesPaymentRejectedConstants
} from '../actions';

const initialState = {
    plannedPayments: {
        total: 0,
        payments: [],
        loading: true
    },
    actualPayments: {
        total: 0,
        payments: [],
        loading: true
    },
    plannedPaymentsInconsistent: {
        filter: {
            isActive: false,
            selectedPeriod: {
                startDate: null,
                endDate: null
            }
        },
        licenses: [{
            licenseId: null,
            errorMessage: null,
            licensePlannedPaymentInconsistencies: []
        }]
    },
    actualPaymentsInconsistent: {
        filter: {
            isActive: false,
            selectedPeriod: {
                startDate: null,
                endDate: null
            }
        },
        licenses: [{
            licenseId: null,
            errorMessage: null,
            licenseActualPaymentInconsistencies: []
        }]
    },
    data: null,
    loading: true,
    loadingUpdate: false,
    loadingAction: false,
    loadingDelete: false,
    loadingActualInconsistent: false,
    loadingPlannedInconsistent: false,
    isLoadingEndDate: false,
    expectedEndDate: null,
    error: '',
};

export default function (state = initialState, action) {
    switch (action.type) {

        case licensesPaymentConstants.LICENSE_CLEAR_PAYMENT:
            return initialState;

        case licensesPaymentPendingConstants.LICENSE_ACTUAL_PAYMENT_CREATED:
        case licensesPaymentPendingConstants.LICENSE_PLANNED_PAYMENT_CREATED:
        case licensesPaymentPendingConstants.LICENSE_PLANNED_PAYMENTS_CREATED:
            return {
                ...state,
                loadingAction: true,
                error: '',
            };

        case licensesPaymentPendingConstants.LICENSE_ACTUAL_PAYMENT_DELETED:
        case licensesPaymentPendingConstants.LICENSE_ACTUAL_PAYMENT_UPDATED:
        case licensesPaymentPendingConstants.LICENSE_PLANNED_PAYMENT_UPDATED:
        case licensesPaymentPendingConstants.LICENSE_PLANNED_PAYMENT_DELETED:
        case licensesPaymentPendingConstants.LICENSE_GET_EXIST_DATE_ACTUAL_LOADED:
        case licensesPaymentPendingConstants.LICENSE_GET_EXIST_DATE_PLANNED_LOADED:
        case licensesPaymentPendingConstants.LICENSE_GET_LAST_DATE_PLANNED_LOADED:
            return {
                ...state,
                loadingAction: true,
            };

        case licensesPaymentPendingConstants.LICENSE_ACTUAL_INCONSISTENT_LOADED:
            return {
                ...state,
                loadingAction: true,
                loadingActualInconsistent: true
            };

        case licensesPaymentPendingConstants.LICENSE_PLANNED_INCONSISTENT_LOADED:
            return {
                ...state,
                loadingAction: true,
                loadingPlannedInconsistent: true
            };

        case licensesPaymentPendingConstants.LICENSE_GET_END_DATE_PLANNED_LOADED:
            return {
                ...state,
                isLoadingEndDate: true,
            };

        case licensesPaymentPendingConstants.LICENSE_PLANNED_PAYMENT_LOADED:
            return {
                ...state,
                plannedPayments: {
                    ...state.plannedPayments,
                    loading: true
                },
            };

        case licensesPaymentPendingConstants.LICENSE_ACTUAL_PAYMENT_LOADED:
            return {
                ...state,
                actualPayments: {
                    ...state.actualPayments,
                    loading: true
                },
            };

        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_INCONSISTENT_LOADED:
            return {
                ...state,
                plannedPaymentsInconsistent: action.payload,
                loadingAction: false,
                loadingPlannedInconsistent: false
            };

        case licensesPaymentFulfilledConstants.LICENSE_ACTUAL_INCONSISTENT_LOADED:
            return {
                ...state,
                actualPaymentsInconsistent: action.payload,
                loadingAction: false,
                loadingActualInconsistent: false
            };

        case licensesPaymentFulfilledConstants.LICENSE_ACTUAL_PAYMENT_DELETED:
        case licensesPaymentFulfilledConstants.LICENSE_ACTUAL_PAYMENT_UPDATED:
        case licensesPaymentFulfilledConstants.LICENSE_ACTUAL_PAYMENT_CREATED:
        case licensesPaymentFulfilledConstants.LICENSE_GET_EXIST_DATE_ACTUAL_LOADED:
        case licensesPaymentFulfilledConstants.LICENSE_GET_EXIST_DATE_PLANNED_LOADED:
        case licensesPaymentFulfilledConstants.LICENSE_GET_LAST_DATE_PLANNED_LOADED:
        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_PAYMENT_UPDATED:
        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_PAYMENT_CREATED:
        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_PAYMENTS_CREATED:
        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_PAYMENT_DELETED:
            return {
                ...state,
                loadingAction: false,
            };

        case licensesPaymentFulfilledConstants.LICENSE_PLANNED_PAYMENT_LOADED:
            return {
                ...state,
                plannedPayments: {
                    ...state.plannedPayments,
                    total: action.payload.total,
                    payments: action.payload.plannedPayments,
                    loading: false
                },
            };

        case licensesPaymentFulfilledConstants.LICENSE_ACTUAL_PAYMENT_LOADED:
            return {
                ...state,
                actualPayments: {
                    ...state.actualPayments,
                    total: action.payload.total,
                    payments: action.payload.actualPayments,
                    loading: false
                },
            };

        case licensesPaymentFulfilledConstants.LICENSE_GET_END_DATE_PLANNED_LOADED:
            return {
                ...state,
                expectedEndDate: action.payload,
                isLoadingEndDate: false
            };

        case licensesPaymentRejectedConstants.LICENSE_ACTUAL_PAYMENT_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_PAYMENT_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_GET_EXIST_DATE_ACTUAL_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_GET_EXIST_DATE_PLANNED_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_GET_END_DATE_PLANNED_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_GET_LAST_DATE_PLANNED_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_ACTUAL_PAYMENT_DELETED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_PAYMENT_DELETED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_PAYMENT_UPDATED:
        case licensesPaymentRejectedConstants.LICENSE_ACTUAL_PAYMENT_UPDATED:
        case licensesPaymentRejectedConstants.LICENSE_SCHEDULE_PAYMENT_UPDATED:
        case licensesPaymentRejectedConstants.LICENSE_SCHEDULE_PAYMENT_CREATED:
        case licensesPaymentRejectedConstants.LICENSE_SCHEDULE_ACTUAL_PAYMENT_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_SCHEDULE_PAYMENT_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_ACTUAL_PAYMENT_CREATED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_PAYMENT_CREATED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_PAYMENTS_CREATED:
        case licensesPaymentRejectedConstants.LICENSE_ACTUAL_INCONSISTENT_LOADED:
        case licensesPaymentRejectedConstants.LICENSE_PLANNED_INCONSISTENT_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    actualPayments: {
                        ...state.actualPayments,
                        loading: false,
                    },
                    plannedPayments: {
                        ...state.plannedPayments,
                        loading: false,
                    },
                    plannedPaymentsInconsistent: initialState.plannedPaymentsInconsistent,
                    actualPaymentsInconsistent: initialState.actualPaymentsInconsistent,
                    loading: false,
                    loadingAction: false,
                    loadingActualInconsistent: false,
                    loadingPlannedInconsistent: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    actualPayments: {
                        ...state.actualPayments,
                        loading: false,
                    },
                    plannedPayments: {
                        ...state.plannedPayments,
                        loading: false,
                    },
                    plannedPaymentsInconsistent: initialState.plannedPaymentsInconsistent,
                    actualPaymentsInconsistent: initialState.actualPaymentsInconsistent,
                    loading: false,
                    loadingAction: false,
                    loadingActualInconsistent: false,
                    loadingPlannedInconsistent: false,
                    error: error.message
                };
            }

            return state;
        }

        default:
            return state;
    }
}
